module.exports = __webpack_public_path__ + "img/0Q3A8622_L_Foamcore.40c4ec2b.jpg";